import { SignIn } from '../components/Authentication/SignIn/SignIn'

export const SignInPage = () => {
    return <SignIn />
}
